<template>
  <b-row class="bg-[#F8F8F8] p-2 items-center rounded">
    <b-col
      v-for="(item, index) in stepsData"
      :key="index"
      class="flex items-center gap-4"
    >
      <div class="flex items-center gap-2 min-w-max">
        <b-icon
          v-show="item.done"
          variant="success"
          scale="1.3"
          icon="check-circle-fill"
        />
        <div
          v-show="!item.done"
          :class="item.number === currentStep ? 'bg-primary' : 'bg-[#828282]'"
          class="h-6 w-6 flex items-center justify-center rounded-full text-white text-sm"
        >
          {{ item.number }}
        </div>
        <div
          :class="{ 'text-primary font-semibold': item.number === currentStep }"
          class="whitespace-nowrap"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        v-if="index < stepsData.length - 1"
        class="border-t flex-1"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'StepsDefault',
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    stepsData: {
      type: Array,
      default: () => [
        {
          number: 1,
          name: 'Step 1',
          done: false,
        },
        {
          number: 2,
          name: 'Step 2',
          done: false,
        },
        {
          number: 3,
          name: 'Step 3',
          done: false,
        },
      ],
    },
  },
  computed: {
    processedSteps() {
      return this.stepsData.map(step => ({
        ...step,
        current: step.number === this.currentStep,
        done: step.done || step.number < this.currentStep,
      }))
    },
  },
}
</script>
